import { AccessorsMutatorsDecorator, Model } from "../../helpers";

/**
 * @class ShomoosApiSetting
 *
 * @property {number} id
 */
export class ShomoosApiSetting extends Model {}

AccessorsMutatorsDecorator(
  "id",
  "request_id",
  "property_id",
  "manager_id",
  "branch_code",
  "branch_secret",
  "from",
  "to",
  "active"
)(ShomoosApiSetting);



// WEBPACK FOOTER //
// ./src/pms-api/models/shomoos-api-setting.model.js